import React from 'react'
import "./style.css"

export default function Tab({ page, setPage }) {
  return (
    <div className='Tab'>
      <div className='Tab_Btn_Con'>
        <button style={{color: page === "Video"? "#fff" : "#000"}} onClick={() => setPage("Video")}>Video</button>
        <button style={{color: page === "Image"? "#fff" : "#000"}} onClick={() => setPage("Image")}>Image</button>
      </div>
      <div className={page === "Image"? 'Tab_Ind Tab_Ind_Right' : 'Tab_Ind'}/>
    </div>
  )
}
